module.exports = __webpack_public_path__ + "img/project_12.0de28dbf.jpg";